import React from "react";
import "./index.scss";

import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { ApplicationState } from "../../store";
import { User } from "../../store/ducks/user/types";
import * as UserActions from "../../store/ducks/user/actions";
import { Param } from "../../store/ducks/param/types";
import * as ParamActions from "../../store/ducks/param/actions";

import Footer from "../../components/Footer";
import SocialButton from "../../components/SocialButton";
import Api from "../../services/api";
import config from "../../config.json";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import InputGroup from "react-bootstrap/InputGroup";

import logoPreta from "../../assets/Images/domakoski-preta.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";

// Add React Helmet to load scripts on this page
// <script src="https://apis.google.com/js/platform.js" async defer></script>

interface StateProps {
  user: User;
  param: Param;
}

interface DispatchProps {
  doLogin(user: User): void;
  setParam(param: Param): void;
}

interface OwnProps {}

type Props = StateProps & DispatchProps & OwnProps;

class Login extends React.Component<Props> {
  api: any = null;
  state: any = null;

  constructor(props) {
    super(props);
    this.api = new Api();
    this.state = {
      redirect: null,
      isLoading: false,
      email: "",
      senha: "",
      hasError: false,
      hasErrorTitle: "",
      hasErrorMsg: "",
      hidden: true,
    };

    this.toggleShow = this.toggleShow.bind(this);
  }

  toggleShow() {
    this.setState({ hidden: !this.state.hidden });
  }

  componentDidMount() {
    const self = this;

    if (self.props.user && self.props.user.status === true) {
      // SE USUARIO ESTIVER LOGADO REDIRECIONA PARA OUTRA PAGINA
      self.setState({ redirect: "/" });
    }
  }

  facebookResponse = (response) => {
    console.log(response);

    // Implementar

    // const tokenBlob = new Blob([JSON.stringify({access_token: response.accessToken}, null, 2)], {type : 'application/json'});

    // const options = {
    //     method: 'POST',
    //     body: tokenBlob,
    //     mode: 'cors',
    //     cache: 'default'
    // };
    // fetch('http://localhost:3000/api/v1/auth/facebook', options).then(r => {
    //     const token = r.headers.get('x-auth-token');
    //     r.json().then(user => {
    //         if (token) {
    //           this.setState({isAuthenticated: true, user, token})
    //         }
    //     });
    // })
  };

  private async handleSocialLoginFailure() {}

  // FAZ TRATAMENTO DA SUBMISSAO FORM DE LOGIN
  private async handleSubmit() {
    const self = this;
    let timeout = 5000;

    if (!this.state.email) {
      self.setState(
        {
          hasError: true,
          hasErrorTitle: "Formulário incompleto",
          hasErrorMsg: "Por favor, digite seu e-mail para continuar.",
        },
        () => {
          setTimeout(() => self.setState({ hasError: false }), timeout);
        }
      );
      return;
    }

    if (!this.state.senha) {
      self.setState(
        {
          hasError: true,
          hasErrorTitle: "Formulário incompleto",
          hasErrorMsg: "Por favor, digite sua senha para continuar.",
        },
        () => {
          setTimeout(() => self.setState({ hasError: false }), timeout);
        }
      );
      return;
    }

    self.setState({
      isLoading: true,
      hasErrorTitle: false,
      hasErrorMsg: "",
    });

    let param = {
      email: self.state.email,
      senha: self.state.senha,
    };

    try {
      const { data } = await self.api.post("/customer/login", param);

      if (!data.status) {
        throw new Error(data.msg);
      } else {
        self.props.doLogin({
          codigo: data.msg.codigo,
          nome: data.msg.nome,
          email: data.msg.email,
          cpf: data.msg.cpf,
          status: true,
          avatar: "",
          token: null,
        });

        self.setState({
          redirect: "/",
          hasError: false,
          hasErrorTitle: "",
          hasErrorMsg: "",
        });
      }
    } catch (e) {
      // console.error(e);
      self.setState(
        {
          hasError: true,
          hasErrorTitle: "Login inválido",
          hasErrorMsg:
            "Não foi possível efetuar login, por favor tente novamente",
        },
        () => {
          setTimeout(() => self.setState({ hasError: false }), timeout);
        }
      );
    } finally {
      self.setState({ isLoading: false });
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    return (
      <>
        {/* <Header/> */}

        <section className="user-page sign-in-session">
          <Row className="user-row-container">
            <Col lg={8} className="user-hero">
              <div className="user-overlay" />
              <article className="cta">
                <h2> Gostaria de aprender novas receitas? </h2>
                <p>
                  {" "}
                  Confira nossa lista de receitas fáceis e rápidas para preparar
                  com nossos produtos!{" "}
                </p>
                <Button className="btn-primary-action btn-user">
                  {" "}
                  <a href="/receitas"> Conferir </a>{" "}
                </Button>
              </article>
            </Col>

            <Col lg={4} className="user-form-col">
              <div className="user-form-container">
                <a href="/" title="Voltar para a Home" className="text-center">
                  {" "}
                  <img
                    src={logoPreta}
                    className="logo-preta"
                    alt="logo Domakoski"
                  />{" "}
                </a>
                <h1> Login </h1>

                {this.state.hasError && (
                  <div className="alert alert-danger mb-0 mt-3">
                    <strong> {this.state.hasErrorTitle} </strong>
                    <br />
                    {this.state.hasErrorMsg}
                  </div>
                )}

                <Form className="w-100 user-login-form">
                  <Form.Group
                    controlId="formGridEmail"
                    className="user-input-container"
                  >
                    <Form.Label> Seu Email </Form.Label>
                    <Form.Control
                      size="lg"
                      type="email"
                      placeholder="Email"
                      className={`user-input input-border ${
                        this.state.hasError ? "input-error" : ""
                      }`}
                      value={this.state.email}
                      onChange={(event) =>
                        this.setState({ email: event.target.value })
                      }
                    />
                  </Form.Group>
                  <Form.Group
                    className="user-input-container"
                    controlId="sign-in-session"
                  >
                    <Form.Label> Sua Senha </Form.Label>
                    <InputGroup>
                      <Form.Control
                        size="lg"
                        type={this.state.hidden ? "password" : "text"}
                        placeholder="Senha"
                        className={`user-input input-border ${
                          this.state.hasError ? "input-error" : ""
                        }`}
                        value={this.state.senha}
                        aria-label="Senha"
                        aria-describedby="Mostrar senha"
                        onChange={(event) =>
                          this.setState({ senha: event.target.value })
                        }
                      />
                      <InputGroup.Append>
                        <Button
                          variant="outline-secondary"
                          className="visibility"
                          onClick={this.toggleShow}
                        >
                          <FontAwesomeIcon
                            icon={this.state.hidden ? faEyeSlash : faEye}
                          />{" "}
                        </Button>
                      </InputGroup.Append>
                    </InputGroup>
                    <a
                      href="/recuperar-senha"
                      title="Recuperar Senha"
                      className="forgot-pswd"
                    >
                      {" "}
                      Esqueceu sua senha?{" "}
                    </a>
                  </Form.Group>
                </Form>
                <span className="actions-btn-wrapper">
                  <input
                    type="submit"
                    value="Entrar"
                    className="btn-primary-action btn-user"
                    title="Entrar"
                    onClick={this.handleSubmit.bind(this)}
                  />

                  <SocialButton
                    provider="facebook"
                    appId={config.FACEBOOK_APP_ID}
                    fiels="name, email, gender, birthday, address"
                    // callback={this.facebookResponse}
                    version="3.1"
                    className="fb-button"
                    onLoginSuccess={this.facebookResponse}
                    onLoginFailure={this.handleSocialLoginFailure}
                  >
                    <FontAwesomeIcon icon={faFacebookF} /> Entrar com Facebook
                  </SocialButton>
                </span>
                {/* <SocialButton
                provider='google'
                appId='271839578784-j9hjrl7kru8jvoa6vkj30imm1pjgf3md.apps.googleusercontent.com'
                className="g-button"
                onLoginSuccess={this.handleSocialLogin}
                onLoginFailure={this.handleSocialLoginFailure}>
                  <FontAwesomeIcon icon={faFacebookF}/> Entrar com Facebook
                </SocialButton> */}
                <h3>
                  {" "}
                  <span className="font-size-16">
                    {" "}
                    Não tem uma conta?{" "}
                  </span>{" "}
                  <a href="/cadastro"> Cadastre-se </a>{" "}
                </h3>
              </div>
            </Col>
          </Row>
        </section>

        {/* <section className="login-container" id="unlogged-user-login">
          <div className="form-container">
            {
              (this.state.isLoading) ? 
              <span>Carregando, aguarde...</span>
              :
              <>
                <h1 className="mt-5"> <span className="heading-border"> Login </span> </h1>
                <div className="input-container" id="unlogged-user-input">

                  {
                    this.state.hasError &&
                    <span>
                      <p className="login-error-title">{this.state.hasErrorTitle}</p>
                      <p className="login-error-msg">{this.state.hasErrorMsg}</p>
                    </span>
                  }

                  <Form className="d-flex w-100 mt-5">
                    <Col>
                      <Form.Row>
                        <Form.Group as={Col} controlId="formGridEmail" className="mb-3">
                          <Form.Label className="ml-3"> Seu Email</Form.Label>
                          <Form.Control type="email" placeholder="Email" className="user-input" value={this.state.email}
                          onChange={(event) => this.setState({email: event.target.value})}/>
                        </Form.Group>
                      </Form.Row>
                      <Form.Row>
                        <Form.Group as={Col} controlId="formGridPassword">
                          <Form.Label className="ml-3"> Sua Senha </Form.Label>
                          <Form.Control type="password" placeholder="Senha" className="user-input" value={this.state.senha}
                          onChange={(event) => this.setState({senha: event.target.value})} />
                        </Form.Group>
                      </Form.Row>
                      <Row>
                        <Col>
                          <a href="/nova_senha" className="ml-3 forgot-pswd">Esqueceu sua senha?</a>
                        </Col>
                      </Row>
                    </Col>
                  </Form>
                  
                </div>
                <input type="submit" value="Entrar" title="Entrar" onClick={this.handleSubmit.bind(this)}></input>
                <h3> <span className="font-size-16"> Não tem uma conta? </span> <a href="/cadastro"> Cadastre-se </a> </h3>
              </>
            }
          </div>
        </section> */}

        <Footer />
      </>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  user: state.user.data,
  param: state.param.data,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ ...UserActions, ...ParamActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Login);
